import React, { useState, useEffect, useRef } from "react";
import { gl_start } from './webgl5.js';

export default function WebGLCanvas() {
  /*
   Creating a simple triangle mesh just
   requires specifying 3 vertices. Note
   that each vertex now has 6 numbers:
   3 for position and 3 for normal.
*/

// ONE TRIANGLE

function Scene() {
  this.mesh = {
    data: new Float32Array([
       0, 1, 0,  0, 0, 1,
      -1,-1, 0,  0, 0, 1,
       1,-1, 0,  0, 0, 1,
    ])
  };
  
  this.vertexSize = 6;

  this.vertexShader = `#version 300 es
    in vec3 aPos, aNor;
    out vec3 vPos, vNor;

    void main() {
      gl_Position = vec4(aPos, 1.);
      vPos = aPos;
      vNor = aNor;
    }`;

  this.fragmentShader = `#version 300 es
    precision highp float;
    in vec3 vPos, vNor;
    out vec4 fragColor;

    void main() {
      fragColor = vec4(vNor, 1.);
    }`;

  this.update = () => {};
}

  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const scene = new Scene();
    gl_start(canvas, scene);

    return () => {
      if (canvas.stopRender) canvas.stopRender();
    };
  }, []);

  return (
    <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
      <canvas ref={canvasRef} width={400} height={400}
        style={{ width: "400px", height: "400px", display: "block", margin: "0 auto", background: "black" }} />
        <pre className = "codeblock-shader">{ Scene.toString() }</pre>
    </div>
  );
}